import { FullUser, UserRole } from 'src/app/swagger-api';
import { SearchCategories } from '../../search/search.enum';
import { NestedBucketIndividualRole } from '../map.enum';

export default class MarkersMappers {
  public static readonly nestedBucketIndividualNameToSearchCategoryMapper: {
    [key in NestedBucketIndividualRole]: SearchCategories;
  } = {
    [NestedBucketIndividualRole.DOCTOR]: SearchCategories.DOCTORS,
    [NestedBucketIndividualRole.MED_STAFF]: SearchCategories.MED_STAFF,
    [NestedBucketIndividualRole.PATIENT]: SearchCategories.PATIENTS,
    [NestedBucketIndividualRole.RESEARCHER]: SearchCategories.RESEARCHERS,
  };

  public static readonly nestedBucketIndividualNameToRoleMapper: {
    [key in NestedBucketIndividualRole]: UserRole;
  } = {
    [NestedBucketIndividualRole.DOCTOR]: UserRole.Doctor,
    [NestedBucketIndividualRole.MED_STAFF]: UserRole.MedStaff,
    [NestedBucketIndividualRole.PATIENT]: UserRole.Patient,
    [NestedBucketIndividualRole.RESEARCHER]: UserRole.Researcher,
  };

  public static readonly diseasesPropRoleMapper: {
    [key: string]: (user: FullUser) => string[];
  } = {
    [UserRole.Doctor]: (user: FullUser) => user.doctor.treatment_of_diseases.map((disease) => disease.title),
    [UserRole.MedStaff]: (user: FullUser) => user.med_staff.treatment_of_diseases.map((disease) => disease.title),
    [UserRole.Patient]: (user: FullUser) => user.patient.diseases.map((disease) => disease.title),
    [UserRole.Researcher]: (user: FullUser) => user.researcher.diseases.map((disease) => disease.title),
  };

  public static readonly specialtiesPropRoleMapper: {
    [key: string]: (user: FullUser) => string[];
  } = {
    [UserRole.Doctor]: (user: FullUser) => user.doctor.specialty.map((s) => s.title),
    [UserRole.MedStaff]: (user: FullUser) => user.med_staff.specialty.map((s) => s.title),
    [UserRole.Patient]: (_user: FullUser) => [],
    [UserRole.Researcher]: (user: FullUser) => user.researcher.specialty.map((s) => s.title),
  };
}
